import { createBrowserRouter } from 'react-router-dom';
import About from '../../components/About/About';
import Article from '../../components/Article/Article';
import Contact from '../../components/Contact/Contact';
import Expertise from '../../components/Expertise/Expertise';
import Home from '../../components/Home/Home';
import Login from '../../components/Login/Login';
import Projects from '../../components/Projects/Projects';
import Main from '../../Main/Main';
import './Router.css';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/home',
                element: <Home></Home>
            },
            {
                path: '/projects',
                element: <Projects></Projects>
            },
            {
                path: '/article',
                element: <Article></Article>
            },
            {
                path: '/expertise',
                element: <Expertise></Expertise>
            },
            {
                path: '/contact',
                element: <Contact></Contact>
            },
            {
                path: '/about',
                element: <About></About>
            },
            {
                path: '/login',
                element: <Login></Login>
            }
        ]
    },
    {
        path: '*',
        element: <div>This is 404 page</div>
    }
])

export default router;

